import { Box, Flex } from "rebass";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { IDomain } from "@hellocontento/contento-common";
import Loader from "components/common/loading/Loader";
import { Headline3 } from "components/common/styles";
import ExploreSource from "components/content/widgets/ExploreSource";
import React, { useEffect, useCallback, useState } from "react";
import { getRecommendedDomains } from "services/news";

import { follow, unfollow, ISource } from "services/news";

import { RecommendationContainer, RecommendationGrid } from "../styles";
import HelperButton from "components/common/form/HelperButton";

const RecommendedDomains: React.FC<{ hideSeeAll?: boolean }> = ({
  hideSeeAll
}) => {
  const history = useHistory();
  const account = useSelector((state: any) => state.account.data);
  const [domains, setDomains] = useState<Array<IDomain>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const navigateTo = (url: string) => {
    history.push(`/accounts/${account.id}/content/${url}`);
  };

  const fetchRecommendedDomains = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await getRecommendedDomains();
      setDomains(response);
      setIsLoading(false);
    } catch (e) {
      console.log(e);
      setIsLoading(false);
    }
  }, []);

  const addSource = async (source: ISource) => {
    try {
      await follow("domains", source.id);
    } catch (_) {}
  };

  const deleteSource = async (source: ISource) => {
    try {
      await unfollow("domains", source.id);
    } catch (_) {}
  };

  useEffect(() => {
    fetchRecommendedDomains();
  }, [fetchRecommendedDomains]);

  return (
    <RecommendationContainer>
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Headline3>Websites</Headline3>
        {!hideSeeAll && (
          <HelperButton
            label={"Explore More"}
            onClick={() => navigateTo("explore?type=websites")}
          />
        )}
      </Flex>
      {isLoading ? (
        <Box
          height={150}
          sx={{
            position: "relative"
          }}
        >
          <Loader location="center" size={32} />
        </Box>
      ) : (
        <RecommendationGrid perColoum={5}>
          {domains.slice(0, 5).map(domain => (
            <ExploreSource
              data={domain}
              type={"domains"}
              key={domain.id}
              onFollowSource={addSource}
              onUnfollowSource={deleteSource}
              onClick={() =>
                history.push(
                  `/accounts/${account.id}/content/domains/${domain.id}`
                )
              }
            />
          ))}
        </RecommendationGrid>
      )}
    </RecommendationContainer>
  );
};

export default RecommendedDomains;
